import { render } from "./ReviewCardLoader.vue?vue&type=template&id=048579b9"
import script from "./ReviewCardLoader.vue?vue&type=script&lang=js"
export * from "./ReviewCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__